<template>
  <b-list-group-item class="border-primary">
    <b-row>
      <b-col>
        <a href="#" @click="goToSentenza()">
          <p class="font-weight-bold" style="font-size: larger">{{ sentenza.titolo }}</p>
        </a>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="2" class="m-2 text-center">
        <b-button variant="outline-danger" @click="goToSentenza()">
          <img :src="base_url + 'cercasentenze/thumbnail/' + sentenza.idNodo"/>
          <!--<br/><br/><font-awesome-icon icon="file-pdf" />-->
          <br/>Testo integrale
        </b-button>
      </b-col>
      <b-col class="text-justify">
        <div v-html="sentenza.contenuto"></div>
      </b-col>
      <b-col sm="2"></b-col>
    </b-row>
    <b-row>
      <b-col sm="12" class="text-center">
        <b-button v-b-toggle="'sentenza-extra-info-'+sentenza.idAtto" variant="outline-dark">
          <font-awesome-icon icon="info-circle" /> Altre info
        </b-button>
      </b-col>
      <b-col sm="12" class="text-center m-2" style="font-size: smaller">
        <b-collapse :id="'sentenza-extra-info-'+sentenza.idAtto">
          <b-row>
            <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="book" /> CATEGORIA:</b-col>
            <b-col md="6" lg="3">{{sentenza.materiaLiv1}}</b-col>
            <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="book" /> MATERIA:</b-col>
            <b-col md="6" lg="3">{{sentenza.materiaLiv2}}</b-col>
          </b-row>
          <b-row>
            <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="book" /> SOTTOMATERIA:</b-col>
            <b-col md="6" lg="3">{{sentenza.materia}}</b-col>
            <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="gavel" /> CODICE UFFICIO:</b-col>
            <b-col md="6" lg="3">{{sentenza.codiceUfficio}}</b-col>
          </b-row>
          <b-row>
            <b-col md="6" lg="3" class="font-weight-bold">
              <font-awesome-icon icon="user-graduate" /> NOME GIUDICE:
            </b-col>
            <b-col md="6" lg="3">{{sentenza.nomeGiudice}}</b-col>
            <b-col md="6" lg="3" class="font-weight-bold">
                <font-awesome-icon icon="address-card" /> CF GIUDICE:
            </b-col>
            <b-col md="6" lg="3">{{sentenza.cfGiudice}}</b-col>
          </b-row>
          <b-row>
            <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="user-tie" /> PARTE:</b-col>
            <b-col md="6" lg="3">{{sentenza.parte}}</b-col>
            <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="user-tie" /> CONTROPARTE:</b-col>
            <b-col md="6" lg="3">{{sentenza.controparte}}</b-col>
          </b-row>
          <b-row>
              <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="hashtag" /> ID ATTO:</b-col>
              <b-col md="6" lg="3">{{sentenza.idAtto}}</b-col>
              <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="hashtag" /> ID FASCICOLO:</b-col>
              <b-col md="6" lg="3">{{sentenza.idFascicolo}}</b-col>
          </b-row>
          <b-row>
              <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="hashtag" /> NUMERO SENTENZA:</b-col>
              <b-col md="6" lg="3">{{sentenza.numeroSentenza}}</b-col>
              <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="calendar-day" /> ANNO SENTENZA:</b-col>
              <b-col md="6" lg="3">{{sentenza.annoSentenza}}</b-col>
          </b-row>
          <b-row>
              <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="hashtag" /> NUMERO RUOLO:</b-col>
              <b-col md="6" lg="3">{{sentenza.numeroRuolo}}</b-col>
              <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="calendar-day" /> ANNO RUOLO:</b-col>
              <b-col md="6" lg="3">{{sentenza.annoRuolo}}</b-col>
          </b-row>
          <b-row>
              <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="gavel" /> GRADO GIUDIZIO:</b-col>
              <b-col md="6" lg="3">{{sentenza.gradoGiudizio}}</b-col>
              <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="hashtag" /> CODICE SEZIONE:</b-col>
              <b-col md="6" lg="3">{{sentenza.codiceSezione}}</b-col>
          </b-row>
          <b-row>
              <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="calendar-day" /> ATTESTAZIONE:</b-col>
              <b-col md="6" lg="3">{{sentenza.attestazione}}</b-col>
              <b-col md="6" lg="3" class="font-weight-bold"><font-awesome-icon icon="calendar-day" /> ULTIMA MODIFICA:</b-col>
              <b-col md="6" lg="3">{{sentenza.ultimaModifica}}</b-col>
          </b-row>
        </b-collapse>
      </b-col>
    </b-row>
  </b-list-group-item>
</template>

<script>
import service from '../../services/service.js';

let getScrollYWrapper = function() {
  return window.scrollY;
}

export default {
  data () {
    return {
      base_url: service.getBaseUrl()
    }
  },
  props: {
    sentenza: {
      idNodo: String,
      titolo: String,
      contenuto: String,
      idAtto: Number,
      idFascicolo: Number,
      codiceUfficio: String,
      materia: String,
      materiaLiv1: String,
      materiaLiv2: String,
      codiceOggetto: String,
      nomeGiudice: String,
      cfGiudice: String,
      parte: String,
      controparte: String,
      numeroSentenza: Number,
      annoSentenza: Number,
      numeroRuolo: Number,
      annoRuolo: Number,
      gradoGiudizio: String,
      codiceSezione: String,
      attestazione: Date,
      ultimaModifica: Date
    },
    filters: Object,
    index: Number
  },
  methods: {
    goToSentenza() {
      this.$router.push({
        name: 'Sentenza',
        params: {
          ...this.sentenza,
          type: 'diMerito',
          filters: this.filters,
          index: this.index,
          scrollY: getScrollYWrapper()
        }
      });
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Search/ResultDiMerito.vue